import store from './store';
import {
  Authenticated,
  fetchUserContext,
  logout,
  setAuthentication,
  setAuthTokens,
  setUser,
  User,
} from './reducer/authentication-slice';

export default store;

export {
  setAuthentication,
  setAuthTokens,
  fetchUserContext,
  logout,
  setUser,
  User,
  Authenticated,
};
